import React, { Component } from "react";
import ModalVideo from "components/ModalVideo/Video";
import PlayButton from "../../assets/images/play-button.svg";
import LazyLoad from "react-lazyload";
import Placeholder from "components/LazyLoad/Placeholder";
import { I18n } from "react-i18next";
import i18n from "../../i18n";

export default class Hero extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
    this.openModal = this.openModal.bind(this);
  }

  openModal() {
    this.setState({ isOpen: true });
  }

  render() {
    const channel = this.props.channel;
    return (
      <I18n>
        {(t, { i18n }) => (
          <div className="page-hero__container">
            <ModalVideo
              channel={channel}
              isOpen={this.state.isOpen}
              videoId={this.props.videoId}
              onClose={() => this.setState({ isOpen: false })}
            />
            <div
              className={
                !this.props.borrel
                  ? `page-hero${this.props.videoId ? " page-hero--video" : ""}`
                  : `page-hero page-hero__borrel`
              }
            >
              <LazyLoad height={450} placeholder={<Placeholder />}>
                <div
                  className={`page-hero__img flex flex-center`}
                  style={{
                    backgroundImage:
                      !this.props.borrel && `url(${this.props.imageSrc})`
                  }}
                >
                  {this.props.borrel ? (
                    <img
                      className={`page-hero__img--borrel`}
                      src={this.props.imageSrc}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                  <div className="page-hero__button flex flex-center flex-column">
                    {this.props.videoId && [
                      <img
                        key="icon"
                        src={PlayButton}
                        onClick={this.openModal}
                        alt="Play-Button"
                      />,
                      <div
                        key="text"
                        className="page-hero__text mt15"
                        style={{
                          display: this.props.showSubtitle ? "block" : "none"
                        }}
                      >
                        {t("videoSubtitle")}
                      </div>
                    ]}
                  </div>
                </div>
              </LazyLoad>
            </div>
          </div>
        )}
      </I18n>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PageHero/Hero.jsx